import { BlockTitle } from "@blocks/Blocks";
import { useSendInViewGTM } from "@pages/SingaporeGe/2025/hooks/useSendInViewGTM";
import { HighlightsProps } from "@pages/SingaporeGe/2025/utils/types";
import TemplateI from "@particles/card/templates/TemplateI/TemplateI";

/**
 * Highlights component to display the top stories section for singapore ge pages.
 * Figma: https://www.figma.com/design/EUTUYjBn7HHbsLRjqK4t5h/GE-2025--WEB---APP-?node-id=11034-4545&t=4NXCtXdS4g1R5hiL-4
 */
const Highlights = ({
  className,
  cardProps,
  gaObject,
}: HighlightsProps): React.ReactElement => {
  const { ref: topStoriesRef } = useSendInViewGTM({
    eventsObject: gaObject?.eventObject,
  });

  return (
    <section
      className={className}
      data-testid={"ge-2025-top-stories-component"}
      ref={topStoriesRef}
    >
      <BlockTitle text="TOP STORIES" rootClassName="mb-4" />

      <TemplateI cardProps={cardProps} />
    </section>
  );
};

export default Highlights;
